import { FetchError } from '@/connection/helpers';
import { GetPublicOauth2IntegrationForChannel, GetSSOIntegrationsForChannel } from '@/connection/integrations/oauth';
import { useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { JacksonSSOOptionstype, Oauth2Integration } from '@/types/registration.types';
import toastTrigger from '@ui/toast/toast-trigger';
import { useEffect, useRef, useState } from 'react';

export default function useLoadSSOs() {
  const activeChannel = useAppSelector(getActiveChannel);
  const [ssos, setSsos] = useState<JacksonSSOOptionstype[]>([]);
  const [publicOauthIntegration, setPublicOauthIntegration] = useState<Oauth2Integration | null>(null);
  const fetching = useRef<number | null>(null);

  useEffect(() => {
    if (!activeChannel || fetching.current === activeChannel) {
      return;
    }

    fetching.current = activeChannel;

    // Reset the state when the channel changes
    setSsos([]);
    setPublicOauthIntegration(null);

    const handleError = (error: Error) => {
      if (error instanceof FetchError) {
        if (error.response.status === 200) {
          return;
        }
      }
      console.error(error);
      toastTrigger('Error loading SSO integrations', {
        type: 'error',
      });
    };

    (async () => {
      GetSSOIntegrationsForChannel(activeChannel).then(setSsos).catch(handleError);
      GetPublicOauth2IntegrationForChannel(activeChannel)
        .then((res) => setPublicOauthIntegration(res || null))
        .catch(handleError);
    })();
  }, [activeChannel]);

  return { ssos, publicOauthIntegration };
}
